import { Box } from '@mui/material';
import { QButton, QDropdownWrapper, QTypography, QTextField } from '@kw/quokka-ui';
import { useState } from 'react';
import { KwFilterWrapper } from '../../kw-ui-components/KwFilterWrapper';

export const AppSearch = ({ searchFunc }: { searchFunc: (appId: string, platform: string) => void }) => {
  const [searchText, setSearchText] = useState('');

  const platformOptions = [
    { value: 'ios', label: 'iOS' },
    { value: 'android', label: 'Android' },
  ];

  const [selectedPlatform, setSelectedPlatform] = useState(platformOptions[0].value);

  return (
    <Box p={2}>
      <QTypography variant="h4Bold">App</QTypography>
      <KwFilterWrapper>
        <QTextField
          value={searchText}
          sx={{ width: '40%', marginTop: 0 }}
          onChange={e => setSearchText(e.target.value)}
          placeholder="Enter application ID"
          margin="normal"
        />
        <QDropdownWrapper
          selectedOption={selectedPlatform}
          closedLabel={platformOptions.find(o => o.value === selectedPlatform)?.label ?? 'Select Platform'}
          formControlProps={{ sx: { width: '120px', height: '40px' } }}
          onChange={e => setSelectedPlatform(e.target.value as string)}
          options={platformOptions}
        />
        <QButton variant="filled" onClick={() => searchFunc(`${searchText}`, selectedPlatform)} sx={{ height: '40px', alignSelf: 'center' }}>
          Search
        </QButton>
      </KwFilterWrapper>
    </Box>
  );
};
